import * as cnames from 'classnames'
import compact from 'lodash-es/compact'
import get from 'lodash-es/get'
import * as React from 'react'

import { IItemCard } from '../interface'

import * as styles from './lockupAudioTrackInfo.module.css'

interface IAttribute {
  name: string
  value: string
}

const LockupAudioTrackInfo = (props: IItemCard) => {
  const attributes = get(props, 'item.attributes', [])
  const bpm = get(
    attributes.filter(({ name }: IAttribute) => name === 'bpm'),
    '[0].value'
  )
  const initialLength = get(
    attributes.filter(({ name }: IAttribute) => name === 'length-audio'),
    '[0].value',
    ''
  )
  const additionalLength =
    get(
      attributes.filter(
        ({ name }: IAttribute) => name === 'length-audio-additional'
      ),
      '[0].value',
      ''
    ) || ''
  const length = compact(additionalLength.split(',')).length + 1

  return (
    <span
      className={cnames(styles.root, {
        [styles.grid]: props.viewType === 'grid'
      })}
    >
      Tracks <span className={styles.bold}>{length}</span>{' '}
      <span className={bpm ? '' : styles.emptyAttribute}>
        BPM <span className={styles.bold}>{bpm ? bpm : '--'}</span>
      </span>
    </span>
  )
}

export default LockupAudioTrackInfo
